import { endpoints } from '~/src/shared/lib/endpoints'

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

export async function apiRequest(url, options = {}) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': csrfToken(),
    ...options.headers,
  }

  const response = await fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers,
  })

  const contentType = response.headers.get('content-type') || ''
  const body = contentType.includes('application/json') ? await response.json() : {}

  if (!response.ok) {
    const errorMessage = body.errors?.[0]?.error || 'Ocurrio un error inesperado'
    throw new Error(errorMessage)
  }

  return body
}

export async function requestData(url, options = {}) {
  const body = await apiRequest(url, options)
  return body.data || {}
}

export const shopApi = {
  products: async (filters = {}) => {
    const params = new URLSearchParams()

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        params.set(key, value)
      }
    })

    const query = params.toString()
    const data = await requestData(endpoints.products.index(query ? `?${query}` : ''))
    return data.products || []
  },
  product: async (slug) => {
    const data = await requestData(endpoints.products.show(slug))
    return data.product || null
  },
  session: () => requestData(endpoints.session.show),
  login: (payload) => requestData(endpoints.session.create, { method: 'POST', body: JSON.stringify(payload) }),
  logout: () => requestData(endpoints.session.destroy, { method: 'DELETE' }),
  register: (customer) => requestData(endpoints.customers.create, { method: 'POST', body: JSON.stringify({ customer }) }),
  requestOtp: (otpVerification) => requestData(endpoints.otpVerifications.create, { method: 'POST', body: JSON.stringify({ otp_verification: otpVerification }) }),
  verifyOtp: (otpVerification) => requestData(endpoints.otpVerifications.verify, { method: 'POST', body: JSON.stringify({ otp_verification: otpVerification }) }),
  cart: () => requestData(endpoints.cart.show),
  addCartItem: (productId, quantity = 1) => requestData(endpoints.cartItems.create, { method: 'POST', body: JSON.stringify({ product_id: productId, quantity }) }),
  updateCartItem: (id, quantity) => requestData(endpoints.cartItems.update(id), { method: 'PATCH', body: JSON.stringify({ quantity }) }),
  clearCart: () => requestData(endpoints.cart.clear, { method: 'DELETE' }),
  submitCheckout: async (checkout) => {
    const data = await requestData(endpoints.orders.create, { method: 'POST', body: JSON.stringify({ checkout }) })
    return data.checkout_request
  },
  checkoutRequests: async () => {
    const data = await requestData('/api/shop/v1/checkout_requests')
    return data.checkout_requests || []
  },
  createOrder: async (checkout) => {
    const data = await requestData(endpoints.orders.create, { method: 'POST', body: JSON.stringify({ checkout }) })
    return data.checkout_request
  },
  order: async (number, token) => {
    const data = await requestData(endpoints.orders.show(number, token))
    return data.order
  },
}
